import { httpRequest } from "@utils/HttpRequest";
import { IPage } from "@src/types/FmsTypes";
import { IMdUserDetail, IMdUserFields, IMdUserSearch, IResetPwd } from "./UserTypes";

class UserService {
    /**
     * 新增用户
     * @param insertVo 
     * @returns 
     */
    async insert(insertVo: IMdUserFields) {
        const userInsertUrl = "/auth/user/insert";
        return await httpRequest.post<IMdUserDetail>(userInsertUrl, insertVo);
    }

    /**
     * 分页获取用户列表
     * @param params 
     * @returns 
     */
    async page(params: IMdUserSearch) {
        const userPageUrl = "/auth/user/page";
        return await httpRequest.post<IPage<IMdUserDetail>>(userPageUrl, params);
    }

    /**
     * 分页获取用户列表-新
     * @param params 
     * @returns 
     */
    async findUserDetail(params: IMdUserSearch) {
        const userPageUrl = "/auth/user/findUserDetail";
        return await httpRequest.post<IPage<IMdUserDetail>>(userPageUrl, params);
    }

    /**
     * 重置密码(管理员)
     * @param params 
     * @returns 
     */
    async updateUserPwd(params: IResetPwd) {
        const userPageUrl = "/auth/user/resetUserPwd";
        return await httpRequest.post<boolean>(userPageUrl, params);
    }


    /**
     * 重置密码
     * @param params 
     * @returns 
     */
    async resetUserPwd(params: IResetPwd) {
        const userPageUrl = "/auth/user/autoResetUserPwd";
        return await httpRequest.post<boolean>(userPageUrl, params);
    }

    /**
     * 重置密码
     * @param params 
     * @returns 
     */
    async resetPwd(params: IResetPwd) {
        const userPageUrl = "/auth/user/resetPwd";
        return await httpRequest.post<boolean>(userPageUrl, params);
    }
    /**
     * 更新用户站点
     * @param params 
     * @returns 
     */
    async updateUserShops(params: IMdUserFields) {
        const userPageUrl = "/auth/user/updateUserShops";
        return await httpRequest.post<boolean>(userPageUrl, params);
    }

    /**
     * 更新用户角色
     * @param params 
     * @returns 
     */
    async updateUserRoles(params: IMdUserFields) {
        const userPageUrl = "/auth/user/updateUserRoles";
        return await httpRequest.post<boolean>(userPageUrl, params);
    }


    /**
     * 用户禁用状态修改
     * @param params 
     * @returns 
     */
    async disable(params: IMdUserFields) {
        const userDisableUrl = "/auth/user/disable";
        return await httpRequest.post<boolean>(userDisableUrl, params);
    }

    /**
     * insertLocal
     * @param params 
     * @returns 
     */
    async insertLocal(params: IMdUserFields) {
        const userDisableUrl = "/auth/user/insertLocal";
        return await httpRequest.post<IMdUserFields>(userDisableUrl, params);
    }

    /**
     * 获取一个用户的全部信息
     * @param params 
     * @returns 
     */
    async oneUser(params: IMdUserFields) {
        const userDisableUrl = "/auth/user/one";
        return await httpRequest.post<IMdUserDetail>(userDisableUrl, params);
    }

    /**
     * 获取一个用户的全部信息
     * @param params 
     * @returns 
     */
    async remove(params: IMdUserFields) {
        const userDisableUrl = "/auth/user/remove";
        return await httpRequest.post<boolean>(userDisableUrl, params);
    }

    /**
     * 更新用户信息
     * @param params 
     * @returns 
     */
    async update(params: IMdUserFields) {
        const userDisableUrl = "/auth/user/update";
        return await httpRequest.post<boolean>(userDisableUrl, params);
    }

    /**
     * 更新本地数据
     * @param params 
     * @returns 
     */
    async updateLocal(params: any) {
        const userDisableUrl = "/auth/user/updateLocal";
        return await httpRequest.post<boolean>(userDisableUrl, params);
    }

    async find(params: IMdUserFields) {
        const userPageUrl = "/auth/user/find";
        return await httpRequest.post<IMdUserDetail[]>(userPageUrl, params);
    }

    async userDs(params: IMdUserFields) {
        let { retData } = await this.find(params);
        return retData.map(el => ({
            label: el.name ?? "",
            value: el.code ?? ""
        }))
    }


    /**
     * 同步
     * @param params 
     * @returns 
     */
    async sync(params: IMdUserFields) {
        const userPageUrl = "/auth/user/sync";
        params.branchList = ["main", "fms"];
        return await httpRequest.post<boolean>(userPageUrl, params, {
            timeout: 15000
        });
    }

    /**
     * syncPage
     * @param params 
     * @returns 
     */
    async syncPage(params: IMdUserSearch) {
        const userPageUrl = "/auth/user/syncPage";
        params.branchList = ["main", "fms"];
        return await httpRequest.post<boolean>(userPageUrl, params);
    }

    /**
     * syncOne
     * @param params 
     * @returns 
     */
    async syncOne(params: IMdUserFields) {
        const userPageUrl = "/auth/user/syncOne";
        params.branchList = ["main", "fms"];
        return await httpRequest.post<boolean>(userPageUrl, params);
    }
    //导出
    async export() {
        const appPageUrl = "/auth/user/exportUserList";
        return await httpRequest.postFile(appPageUrl, {}, { timeout: 30000 });
    }
    //禁用启用
    async disableUser(userCode: string, status: number) {
        const appPageUrl = `/auth/user/updateUserStatus/${userCode}/${status}`;
        return await httpRequest.post<boolean>(appPageUrl);
    }
    //查询该工号是否被占用
    async findStaff(staffId: string) {
        const appPageUrl = `/auth/user/findStaffId/${staffId}`;
        return await httpRequest.post<boolean>(appPageUrl);
    }
    //禁用启用
    async findUserCode(userCode: string) {
        const appPageUrl = `/auth/user/findUserCodeExist/${userCode}`;
        return await httpRequest.post<boolean>(appPageUrl);
    }
    //更新用户组织机构
    async updateUserOrg() {
        const appPageUrl = `/auth/user/updateUserOrg`;
        return await httpRequest.post<boolean>(appPageUrl);
    }
    //部门迁移
    async transferOrg(oldOrg: string, newOrg: string) {
        const appPageUrl = `/auth/user/transferOrg/${oldOrg}/${newOrg}`;
        return await httpRequest.post<boolean>(appPageUrl);
    }
}

export const userService = new UserService();
